import{a as e}from"./chunk-FCO72CCF.js";import{a as m}from"./chunk-6AAYEFVP.js";import{n as r,o}from"./chunk-5NG2JD2X.js";var i=new r({locale:[e,m,o]});export{i as a};
